import {
  clearChunkReloadFlag,
  isChunkError,
  reloadForChunkErrorOnce,
} from "~/utils/chunk-reload.utils";

export default defineNuxtPlugin((nuxtApp) => {
  // Nuxt's own chunk error hook (route-level dynamic imports).
  nuxtApp.hook("app:chunkError", ({ error }) => {
    if (!reloadForChunkErrorOnce()) {
      console.error("[chunk-reload] chunk still missing after reload", error);
    }
  });

  // Component-level `await import(...)` failures that aren't swallowed by
  // Vue's errorHandler (e.g. raised outside of a lifecycle hook).
  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkError(event.reason)) return;
    if (!reloadForChunkErrorOnce()) {
      console.error(
        "[chunk-reload] chunk still missing after reload",
        event.reason,
      );
    }
  });

  // Synchronous module script loading errors.
  window.addEventListener("error", (event) => {
    if (!isChunkError(event.error) && !isChunkError(event.message)) return;
    if (!reloadForChunkErrorOnce()) {
      console.error(
        "[chunk-reload] chunk still missing after reload",
        event.error ?? event.message,
      );
    }
  });

  // Lazy `import()` calls in component `onMounted` hooks run after
  // `app:mounted`. Wait long enough for those to resolve (or fail) before
  // declaring the reload successful — otherwise a second failure would
  // re-arm the flag and we'd loop.
  nuxtApp.hook("app:mounted", () => {
    setTimeout(clearChunkReloadFlag, 10_000);
  });
});
